import { X } from 'lucide-react';
import { useState } from 'react';

export const MegaMenuExistingCustomersContent = ({ menuItems }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const handleModalToggle = (event) => {
    event.preventDefault(); // Prevent default link behavior
    setModalOpen(!isModalOpen);
  };

  return (
    <>
      <div className="grid grid-cols-2 w-[55rem] gap-2">
        {/* Left Section */}
        <div className="h-[460px] px-3 py-8 bg-[#fcfcff]">
          {menuItems.map((item, index) => (
            <a
              href={item.href}
              key={index}
              className="p-5 rounded-lg flex flex-col justify-start items-start gap-2 hover:bg-[#F3F4F8] cursor-pointer"
            >
              <div className="items-center gap-2">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6">{item.icon}</div>
                  <div className="mega-menu-submenu-title">{item.title}</div>
                </div>
                <div className="mega-menu-submenu-text lg:w-[20rem] mt-2">{item.description}</div>
              </div>
            </a>
          ))}
        </div>

        {/* Right Section */}
        <div className="h-[460px] px-6 py-8 bg-[#f3f4f8]">
          <div>
            <p className="text-[#0C0D1A] text-xl font-semibold mt-2 mb-4">
              A guide to equity release: things for you to consider
            </p>

            <p className="text-[#373945] font-450 mb-4">
              Watch this video to learn about lifetime mortgages.
            </p>

            <a href="https://www.youtube.com/@pureretirementforourcustom6170/videos">
              <div className="inline-flex gap-2">
                <p className="text-[#A51367] font-semibold mb-4">
                  Visit our YouTube page
                </p>

                <div className="pt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                    <path d="M2.66669 8.93921H13.3334M13.3334 8.93921L9.33335 4.93921M13.3334 8.93921L9.33335 12.9392"
                      stroke="#A51367"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </a>
          </div>

          {/* Video Link */}
          <div className="relative w-full h-[12rem] mt-4 rounded-lg">
            <div onClick={handleModalToggle}>
              <img
                src="/img/b2c/navbar/img_3.webp"
                alt="img-3"
                loading="lazy"
                className="object-cover rounded-lg h-[12rem] w-full"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <img src="/img/icons/play_button-alt.svg" alt="Placeholder" loading="lazy" className="w-20 h-20" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 h-[100vh] lg:-mt-6 xl:-mt-3.5">
          <div className="relative w-full max-w-2xl -mt-40">
            {/* Close Button */}
            <button
              onClick={handleModalToggle}
              className="absolute -top-10 right-1 p-1 text-gray-600 hover:text-gray-900"
            >
              <X className="w-10 h-10 text-white" />
            </button>
            {/* Video Content */}
            <div className="w-full aspect-video">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/jmy8Hn2aIQU?si=hrlX0t7MXxtSz7nM" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
              </iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
